<!-- https://8es9hr.axshare.com/#g=1&p=%E5%80%9F%E6%93%9A%E9%82%84%E6%AC%BE%E8%A9%A6%E7%AE%97 -->
<!-- 借據還款試算 -->
<template>
	<div class="row">
		<div class="col-12">
			<div class="col-block">
				<div class="block-header has-border">
					<h3>
						<strong>借據還款試算</strong>
					</h3>
				</div>
				<div class="block-content">
					<el-form ref="form" :model="form">
						<el-form-item label="請輸入試算日期">
							<div class="date">
								<input
									type="text"
									class="min_go_date baseDate"
									placeholder="選擇日期"
								/>
								<span class="el-input__prefix">
									<i class="el-icon-date"></i>
								</span>
							</div>
							<el-button
								type="primary"
								@click="trialCalc"
								class="ml10"
								>試算</el-button
							>
						</el-form-item>
						<div class="title-border mb10">{{ baseDate }}</div>
						<el-form-item label="每期應還金額">{{
							$addcomma(calResult.stageLoanPay)
						}}</el-form-item>
						<el-form-item label="上次還款日期">{{
							$transferDate(calResult.lastPayDate)
						}}</el-form-item>
						<el-form-item label="還款前本金">{{
							$addcomma(calResult.loanPriceBeforePay)
						}}</el-form-item>
						<el-form-item label="還款後剩餘本金">{{
							$addcomma(calResult.loanPriceAfterPay)
						}}</el-form-item>
						<el-form-item label="當下利率"
							>{{ calResult.normalAnnualRate }}%</el-form-item
						>
						<el-form-item label="還款寬限日"
							>{{ calResult.securedGraceDay }} 天</el-form-item
						>
						<el-form-item label="違約金利率"
							>{{ calResult.loanPenalty }}%</el-form-item
						>
						<el-form-item label="前欠利息">{{
							$addcomma(calResult.interestNotPayBefore)
						}}</el-form-item>
						<el-form-item label="前欠違約金">{{
							$addcomma(calResult.breakNotPayBefore)
						}}</el-form-item>
						<el-form-item label="協議前欠金額">{{
							$addcomma(agrBackpayAmount)
						}}</el-form-item>
						<el-form-item label="應還利息減免金額">{{
							$addcomma(calResult.interestAmountReduction)
						}}</el-form-item>
						<el-form-item label="應還違約金減免金額">{{
							$addcomma(calResult.breakAmountReduction)
						}}</el-form-item>

						<el-form-item label="應繳本金">{{
							$addcomma(calResult.payBackLoanPrice)
						}}</el-form-item>
						<el-form-item label="應繳利息(含前欠)">{{
							$addcomma(calResult.payBackInterest)
						}}</el-form-item>
						<el-form-item label="應繳違約金(含前欠)">{{
							$addcomma(calResult.payBackBreakPrice)
						}}</el-form-item>
						<el-form-item>
							<div
								v-for="(detail, index) in calResult.detail"
								:key="index"
							>
								<table class="table table-bordered mb-0">
									<thead class="grey lighten-4">
										<tr>
											<th colspan="3">
												<h3>
													<strong>
														第{{detail.stage}}期
													</strong>
													<span v-show="index === 0" class="text-danger">
														【應還本金如有提前部分清償(超還本金)，試算時顯示期數為應還本金之期數。】
													</span>
												</h3>
											</th>
										</tr>
									</thead>
									<thead class="grey lighten-4">
										<tr>
											<th>應還項目</th>
											<th>應還金額</th>
											<th>金額細節</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>應還本金</td>
											<td>
												{{
													$addcomma(
														detail.stageLoanPay
													)
												}}
											</td>
											<td></td>
										</tr>
										<tr>
											<td>應還利息</td>
											<td>
												{{
													$addcomma(
														detail.stageInterest
													)
												}}
											</td>
											<td style="overflow-x: scroll">
												<p
													style="
														white-space: nowrap;
														width: 150px;
													"
												>
													{{
														renderCauculateString(
															detail.interestRateDetail,
															detail.paymentType
														)
													}}
												</p>
											</td>
										</tr>
										<tr>
											<td>應還違約金</td>
											<td>
												{{
													$addcomma(detail.breakPrice)
												}}
											</td>
											<td style="overflow-x: scroll">
												<p
													style="
														white-space: nowrap;
														width: 150px;
													"
												>
													{{
														renderCauculateString(
															detail.breakPriceDetail,
															1,
															true
														)
													}}
												</p>
											</td>
										</tr>
										<tr>
											<td>總計</td>
											<td>
												{{
													$addcomma(
														detail.stagePayBack
													)
												}}
											</td>
											<td></td>
										</tr>
									</tbody>
								</table>
							</div>
						</el-form-item>
						<el-form-item label="總還款金額"
							>{{
								$addcomma(calResult.payBackPrice)
							}}元</el-form-item
						>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import moment from "moment";
import { API } from "@/assets/config";
export default {
	name: "after_trial_calc",
	props: ["recordToEdit"],
	data() {
		return {
			calResult: {},
			agrBackpayAmount: undefined,
			baseDate: "",
			form: {},
		};
	},
	watch: {},
	methods: {
		renderCauculateString(
			interestRateDetail,
			paymentType,
			isBreakPrice = false
		) {
			let result = "";
			interestRateDetail.forEach((rateDetail) => {
				let date = {
					beginDate: this.$transferDate(rateDetail.beginDate),
					endDate: this.$transferDate(rateDetail.endDate),
				};

				let dateDiff = rateDetail.dateDiff;
				let interestRate = rateDetail.interestRate;
				let interest =
					paymentType == 2
						? rateDetail.interestMonthly
						: rateDetail.interestDaily;
				let loanPrice = rateDetail.loanPrice;
				result += `${date["beginDate"]} ~ ${
					date["endDate"]
				} ${dateDiff}天 ${
					isBreakPrice ? "利息" : "本金"
				}${this.$addcomma(
					loanPrice || "0"
				)}元 年利率 ${interestRate}% 共 ${this.$addcomma(
					interest || "0"
				)} 元 `;
			});
			return result;
		},
		trialCalc() {
			this.baseDate = $(`.baseDate`).val();
			let date =
				parseInt($(`.baseDate`).val().split("-")[0]) +
				1911 +
				$(`.baseDate`).val().slice(3);

			// 協議前欠金額
			const iouId = this.$route.params.id;
			if (iouId) {
				const agrUrl =
					API.coopLoanIou +
					`?action=getAgrBackpay&coopLoanIouId=${iouId}&baseDate=${date}`;
				this.mAxiosGet(agrUrl, (json) => {
					let sumAmount = 0;
					const data =
						(json.resultData && json.resultData.data) || {};
					Object.keys(data).forEach((_key) => {
						const calculateObject = data[_key];
						if (calculateObject && calculateObject.length > 0) {
							const price =
								calculateObject[calculateObject.length - 1]
									.backPayPriceTotal || 0;
							// 比照現金收款：僅加總 > 0 的協議前欠
							if (price > 0) {
								sumAmount += price;
							}
						}
					});
					this.agrBackpayAmount = sumAmount;
				});
			} else {
				this.agrBackpayAmount = undefined;
			}

			const url = API.coopLoanIou + "?action=getCalByDate";
			let dataPost = new FormData();

			dataPost.append("iouNumber", this.recordToEdit.iouNumber);
			dataPost.append("baseDate", date);

			const postCB = (json) => {
				this.calResult = json.resultData;

				this.calResult.detail.forEach(function (val) {
					val.interestRateDetail.forEach(function (diff) {
						if (!(diff.showDateRange == "")) {
							var tmpDateRange = diff.showDateRange.split("~");
							diff.showDateStart = tmpDateRange[0];
							diff.showDateEnd = tmpDateRange[1];
						}
					});
				});
			};
			this.mAxiosPost(url, dataPost, postCB);
		},
	},
};
</script>
<style lang="scss" scoped>
.title-border {
	border-bottom: 1px solid #e9e9e9;
	border-top: 1px solid #e9e9e9;
	padding: 15px 0;
	line-height: 1.5;
}
</style>